import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';
import { SimpleMatTooltipModule } from "../simple-mat-tooltip/simple-mat-tooltip.module";
import { GeoChartJsonService } from "./services";
import {  MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { CountriesMapChartComponent, StatesMapChartComponent } from "./components/map-chart";
import { BarChartComponent } from "./components/bar-chart/bar-chart.component";
import { WordCloudChartComponent } from "./components/word-cloud-chart";
import { LineChartComponent } from './components/line-chart/line-chart.component';

@NgModule({
  declarations: [BarChartComponent, WordCloudChartComponent, StatesMapChartComponent, CountriesMapChartComponent, LineChartComponent],
  exports: [BarChartComponent, WordCloudChartComponent, StatesMapChartComponent, CountriesMapChartComponent, LineChartComponent],
  imports: [
    DisableAutocompleteDirectiveModule,
    CommonModule,
    SimpleMatTooltipModule,
    MatProgressSpinnerModule
  ],
  providers: [GeoChartJsonService]
})
export class ChartsModule {}
